var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-downloader',{scopedSlots:_vm._u([{key:"default",fn:function(downloaderProps){return [_c('a',{on:{"click":function($event){return downloaderProps.download(_vm.file)}}},[_vm._v("download")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }